export const V1_HEADERS: Record<string, readonly string[]> = {
  "data-dictionary.tsv": [
    "dict_type", "code", "name", "param_format", "value", "description",
  ],
  "game-rules.tsv": [
    "rule_id", "game_name", "max_level", "skill_level_count", "party_size",
    "player_actor_id", "equipment_slots", "start_map_id", "start_entry_id",
    "death_map_id", "death_entry_id", "revive_hp_percent", "revive_mp_percent",
    "initial_gold", "initial_items", "level_up_recover_all", "max_tp",
    "tp_initial_random_max_exclusive", "tp_damage_charge_multiplier",
    "tp_regeneration_multiplier", "actor_max_hp", "actor_max_mp", "actor_max_stat",
    "enemy_max_hp", "enemy_max_mp", "enemy_max_stat", "max_gold", "max_damage",
    "max_healing", "minimum_damage", "item_stack_limit", "weapon_bag_limit",
    "armor_bag_limit", "basic_attack_skill_id",
    "skill_cooldown_after_battle_adjustment", "skill_cooldown_map_step_interval",
    "skill_cooldown_map_step_reduction", "hit_formula_code", "critical_formula_code",
    "critical_flat_bonus", "critical_damage_percent", "action_order_formula_code",
    "enemy_action_formula_code", "drop_formula_code", "escape_enabled",
    "escape_agility_multiplier", "escape_failure_boost", "default_sell_percent",
    "shop_buy_rounding_code", "shop_sell_rounding_code",
    "equipment_recycle_rounding_code", "batch_sale_protect_quality_id",
    "set_bonus_mode", "normal_spawn_min_distance", "life_steal_hp_overheal",
    "life_steal_mp_overheal", "life_steal_allow_negative_hp",
    "life_steal_allow_negative_mp", "auto_battle_enabled", "auto_battle_default",
    "auto_battle_persist", "legendary_perk_chance_percent",
    "mythic_perk_chance_percent",
  ],
  "actors.tsv": [
    "actor_id", "actor_name", "sprite_sheet", "sprite_index", "face_sheet",
    "face_index", "initial_level", "max_level", "initial_equipment", "traits",
    "passive_states", "description",
  ],
  "levels.tsv": [
    "actor_id", "level", "exp_required", "max_hp", "max_mp", "attack", "defense",
    "magic_attack", "magic_defense", "agility", "luck", "learn_skills",
  ],
  "skills.tsv": [
    "skill_id", "skill_name", "skill_type", "icon_sheet", "icon_index",
    "animation_id", "scope_id", "occasion_id", "hit_type_id", "damage_type_id",
    "element_id", "formula_code", "repeats", "speed", "success_rate_percent",
    "cooldown_turns", "cost_type", "tp_gain", "critical", "critical_rate_percent",
    "variance_percent", "required_weapon_types", "effects", "traits",
    "passive_states",
    "max_hp", "max_mp", "attack", "defense", "magic_attack",
    "magic_defense", "agility", "luck",
    ...Array.from({ length: 10 }, (_, index) => `cost_${index}`),
    ...Array.from({ length: 10 }, (_, index) => `power_${index}`),
    "extra_type",
    ...Array.from({ length: 10 }, (_, index) => `extra_${index}`),
    "description",
  ],
  "states.tsv": [
    "state_id", "state_name", "icon_sheet", "icon_index", "priority",
    "restriction_id", "motion_id", "overlay_id", "auto_remove_timing",
    "minimum_turns", "maximum_turns", "remove_at_battle_end",
    "remove_by_restriction", "remove_by_damage", "damage_remove_chance_percent",
    "remove_by_walking", "steps_to_remove", "traits", "life_steal", "effects",
    "description",
  ],
  "enemies.tsv": [
    "enemy_id", "enemy_name", "enemy_rank", "sprite_sheet", "sprite_index",
    "max_hp", "max_mp", "attack", "defense", "magic_attack", "magic_defense",
    "agility", "luck", "exp", "gold", "actions", "traits", "passive_states",
    "life_steal", "drops",
  ],
  "troops.tsv": ["troop_id", "troop_name", "can_escape", "members"],
  "items.tsv": [
    "item_id", "item_name", "item_type", "icon_sheet", "icon_index",
    "animation_id", "description", "max_stack", "buy_price", "sell_price",
    "use_place", "target_type", "consumable", "success_rate_percent",
    "required_level", "effects",
  ],
  "equipment.tsv": [
    "equipment_id", "equipment_name", "equipment_type", "weapon_type_id",
    "armor_type_id", "quality_id", "icon_sheet", "icon_index", "sort_order",
    "required_level", "can_remove", "can_sell", "max_hp", "max_mp", "attack",
    "defense", "magic_attack", "magic_defense", "agility", "luck", "buy_price",
    "sell_price", "affix_rules", "traits", "passive_states", "life_steal",
    "description",
  ],
  "equipment-affixes.tsv": [
    "affix_id", "affix_name", "affix_type", "quality_id", "sort_order",
    "price_delta", "max_hp", "max_mp", "attack", "defense", "magic_attack",
    "magic_defense", "agility", "luck", "random_stat_code", "random_min",
    "random_max", "random_price_per_point", "traits", "passive_states",
    "life_steal", "granted_skills", "boss_enemy_id", "proc_chance_percent",
    "proc_damage_percent", "skill_damage_bonus_percent", "special_pool",
    "minimum_quality_id", "description",
  ],
  "quality-profiles.tsv": [
    "profile_id", "profile_name", "quality_1_percent", "quality_2_percent",
    "quality_3_percent", "quality_4_percent", "quality_5_percent",
    "quality_6_percent", "points_2_min", "points_2_max", "points_3_min",
    "points_3_max", "points_4_min", "points_4_max", "points_5_min",
    "points_5_max", "points_6_min", "points_6_max",
    "exceptional_chance_multiplier", "description",
  ],
  "equipment-sets.tsv": [
    "set_id", "set_name", "member_equipment", "bonus_2", "bonus_3", "bonus_4",
    "bonus_5", "bonus_6", "bonus_7", "bonus_8", "description",
  ],
  "boss-loot.tsv": [
    "boss_enemy_id", "boss_name", "drop_chance_percent", "minimum_quality_id",
    "equipment_pool", "ability_affix_pool", "description",
  ],
  "maps.tsv": [
    "map_id", "map_name", "width", "height", "tileset_id", "matrix",
    "default_entry_id", "npc_defs", "normal_troops", "normal_max_alive",
    "normal_respawn_seconds", "boss_respawn_seconds", "bgm_id",
    "normal_quality_profile_id", "boss_quality_profile_id",
  ],
  "shops.tsv": [
    "shop_id", "shop_name", "buy_enabled", "sell_enabled", "buy_rate_percent",
    "sell_rate_percent", "sell_entry_types", "goods", "description",
  ],
};
